import { Platform } from 'react-native';
import * as Device from 'expo-device';

import { filterArrayEmpty } from 'lib/riskbase';
import { version as appVersion } from '../../version.json';

export const getDeviceLineBreak = (): '\n' | '%0D%0A' =>
  Platform.OS === 'ios' ? '\n' : '%0D%0A';

export const APP_VERSION = appVersion;

export const getDeviceString = (): string =>
  [
    Platform.OS === 'web' ? 'Web' : null,
    Device.modelName,
    Device.modelId
      ? Device.modelName
        ? `(${Device.modelId})`
        : Device.modelId
      : null,
    Device.osName,
    Device.osVersion,
  ]
    .filter(filterArrayEmpty)
    .join(' ');

export const getInfoDump = (userID: string): string => {
  return [
    `Version: ${APP_VERSION}`,
    `User: RB-${userID}`,
    `Time: ${new Date().toISOString()}`,
    `Platform: ${getDeviceString()}`,
  ]
    .filter((value) => !!value)
    .join(getDeviceLineBreak());
};
